import { style } from '@genially/design-system';
import type { GraphicsScale } from '@genially/design-system/build/style/types/theme';

const BACKGROUND_COLORS = [
  style.themes.newPrimary.color.background.secondary.default,
  style.themes.newPrimary.color.background.premium.default,
  style.themes.newPrimary.color.background.success.default,
  style.themes.newPrimary.color.background.error.default,
  style.themes.newPrimary.color.background.accent.disabled,
  style.themes.newPrimary.color.background.primary.default,
  style.themes.newPrimary.color.background.warning.default,
];

export const getInteractiveQuestionsRankingColor = (hash: number) => {
  const colorIndex = hash % 18;

  if (colorIndex < 11) {
    return style.themes.newPrimary.color.background.complementary(
      (colorIndex + 1) as keyof GraphicsScale,
    );
  }

  return BACKGROUND_COLORS[colorIndex - 11]();
};
